<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Add New Task</h2>
  <mat-dialog-content>
    <form class="todolist-add-form" [formGroup]="form">
      <mat-form-field class="example-full-width">
        <input matInput placeholder="Task Name" formControlName="name" [(ngModel)]="name" name="name" required>
      </mat-form-field>
        <mat-slide-toggle *ngIf="nationalEnabled" floatLabel="always" appearance="none" color="primary" formControlName="national"
            id="national" [(ngModel)]="national" (ngModelChange)="nationalChanged($event)" i18n="@@type.ToDoEntry.national">
            National </mat-slide-toggle>
      <mat-form-field  class="example-full-width" matTooltip="Select a Business Unit from the list">
        <mat-label i18n="@@type.todoEntry.businessUnit">Business Unit</mat-label>
        <mat-select required (selectionChange)="businessUnitChanged($event)" formControlName="businessUnit"
          placeholder="BusinessUnit" [(ngModel)]="businessUnit" [compareWith]="compareBusinessUnit" [disabled]="national">
          <mat-option *ngFor="let businessUnit of businessUnits" [value]="businessUnit">
            {{businessUnit.buId}} - {{businessUnit.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input matInput [matDatepicker]="picker" placeholder="Due date" [(ngModel)]="date" name="date" color="primary"
          required formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker color="primary"></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <textarea matInput placeholder="Description" formControlName="description" [(ngModel)]="description" name="description"></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="addEntry()">Add</button>
  </mat-dialog-actions>
</div>
